import { Field, Form, Formik } from "formik";
import React, { useContext, useRef } from "react";
import { FormContext } from "../../../App";
import { Container, Paper } from "@mui/material";
import { styled } from "@mui/system";
import DataLayerService from "utility/dataLayerService";
import TermAndCondition from "components/atoms/TermAndCondition";
import LeafBox from "components/atoms/LeafBox";
import { scrollToTop } from '../../../utility/functions';

// Import SVG Icons.
import { LeafButton } from "components/atoms/LeafButtons";
import { useComponentName, useProduct } from "hooks";

const RequestedCompletion = (props) => {
  const location = props.dataSet?.location ? props.dataSet.location : "multi-step-modal-form";
  const form = props.dataSet?.form ? props.dataSet.form : "modal";
  const userJourneyTracking = props.dataSet?.tracking || '';
  const componentName = props.component || 'ZipChecker';
  const formName = useComponentName(componentName);
  const product = useProduct();
  const subformName = useComponentName(props.modalComponent);
  const formHeader = props.dataSet?.formheader ? props.dataSet.formheader : "Get a FREE Estimate for a LeafFilter Gutter Guard System";
  const formRef = useRef(null);
  const homelevel = props.dataSet?.homelevel ? props.dataSet.homelevel : '';
  const rentown = props.dataSet?.rentown ? props.dataSet.rentown : '';

  const { activeStepIndex, setActiveStepIndex, formData, setFormData } =
    useContext(FormContext);

  const prevStep = () => {

    let stepNumber = 0;
    if (homelevel) {
      stepNumber = 1;
    }
    if (rentown) {
      stepNumber = 2
    }

    setActiveStepIndex(stepNumber);
  };

  const handleOnBlur = (event) => {
    // Passing lf.form.interaction event to DataLayer.
    DataLayerService.formInteractionEvent(form, location);
  };

  const StyledFormContainer = styled(Paper)(({ theme }) => ({
    background: "#ffffff",
    padding: `${theme.spacing(2)}`,
    borderRadius: 8,
    width: "100%",
    height: "auto",
  }));

  return (
    <Formik
      initialValues={{
        requestedcompletion: formData.requestedcompletion || '',
      }}
      onSubmit={(values) => {
        const data = { ...formData, ...values };
        setFormData(data);
        setActiveStepIndex(activeStepIndex + 1);

        // Scroll to the Top.
        scrollToTop(formRef);

        if (userJourneyTracking) {
          let stepNumber = activeStepIndex + 1;
          if (componentName === 'ModalForm') {
            stepNumber += 1;
          }

          // Passing lf.form.status event to DataLayer.
          DataLayerService.formStatusEvent(formName, subformName, product, stepNumber, 1, 'notcompleted');
        }

        // Passing lf.form.start event to DataLayer.
        DataLayerService.formStartEvent(form, location, data);
      }}
    >
      {({ handleSubmit, setFieldValue, isSubmitting, onNext, onBack }) => (
        <Container maxWidth={"sm"} disableGutters={true}>
          <StyledFormContainer>
            <Form
              className="flex rent-own flex-col justify-center items-start"
              onSubmit={handleSubmit}
              ref={formRef}
              onBlur={
                (event) => { handleOnBlur(event) }
              }
            >
              <h3 className="fw-semibold c--dark-charcoal">{ formHeader }</h3>
              <LeafBox>
                <label className="font-medium text-green-600">
                  When do you need this work done?
                </label>
                <Field name="requestedcompletion">
                  {({ field }) => (
                    <LeafBox>
                      <label className="Story">
                        <input
                          type="radio"
                          {...field}
                          value="Urgent"
                          checked={field.value === "Urgent"}
                        />
                        Urgent
                      </label>
                      <label className="Story">
                        <input
                          type="radio"
                          {...field}
                          value="Within 2 weeks"
                          checked={field.value === "Within 2 weeks"}
                        />
                        Within 2 weeks
                      </label>
                      <label className="Story">
                        <input
                          type="radio"
                          {...field}
                          value="More than 2 weeks"
                          checked={field.value === "More than 2 weeks"}
                        />
                        More than 2 weeks
                      </label>
                      <label className="Story">
                        <input
                          type="radio"
                          {...field}
                          value="Not sure/still planning"
                          checked={field.value === "Not sure/still planning"}
                        />
                        Not sure/still planning
                      </label>
                    </LeafBox>
                  )}
                </Field>
              </LeafBox>

              <LeafButton buttonType={"primary"} type="submit" isSubmitting={isSubmitting} style={{
                width: "100%"
              }}>
                Next
              </LeafButton>

              <div className="back-button">
                <LeafButton buttonType={"secondary"} onClick={prevStep}>
                  Back
                </LeafButton>
              </div>
              <TermAndCondition />
            </Form>
          </StyledFormContainer>
        </Container>
      )}
    </Formik>
  );
}

export default RequestedCompletion;
